import { Button } from '@/components/atoms';
import PATH from '@/routes/path';
import { useSelector } from 'react-redux';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import AuthContainer from './AuthContainer';
// --- Ganti dengan path gambar yang sesuai ---
import imgSuccess from '@/images/success-buy-course.png';

const RegisterSuccess = () => {
    const client = useSelector((state) => state.client);
    const { t } = useTranslation();

    return (
        <AuthContainer>
            <div className="text-center px-2">
                <h1 className="text-2xl font-bold mb-4 text-primary">
                    {t('auth_register_success_title')}
                </h1>
                <p className="text-gray-600 mb-6 text-base">
                    {client.payload?.name
                        ? t('auth_register_success_thank_you').replace(
                            '[CLIENT_NAME]',
                            client.payload.name
                        )
                        : '...'}
                </p>

                <img
                    src={imgSuccess}
                    alt="Registration Success"
                    className="mx-auto mb-6 w-48 h-auto"
                />

                <p className="text-gray-500 text-base mb-8">
                    <Trans i18nKey="auth_register_success_check_email">
                        <strong />
                    </Trans>
                </p>
            </div>
        </AuthContainer>
    );
};

export default RegisterSuccess;
